module.exports = __webpack_public_path__ + "img/horizontal_3_1_pp1_9006.5dea80d2.png";